document.addEventListener('alpine:init', () => {
  Alpine.data('bundles', () => ({
    loaded: false,
    async init() {
      const dynamicBox = await this.fetchVariantData();
      this.formSellingPlanValue = document.querySelector('[name="selling_plan"]:checked').value;
      if (dynamicBox.ok) {
        console.log(dynamicBox, 'dynamicBox');
        this.box = dynamicBox.DynamicBox;
        this.maxQty = 4;
        this.minQty = 4;
      }
      const plan = Object.entries(this.box.sellingPlanGroup).find(([_, plan]) => plan.intervalCount === 30);
      const planId = plan ? plan[0].replace('gid://shopify/SellingPlan/', '') : '';
      this.currentSellingPlan = planId;
      this.loaded = true;
    },

    currentSellingPlan: null,
    box: null,
    slots: [],
    thresholds: [],
    totalSlotsQuantity: 0,
    maxQty: null,
    minQty: 0,
    flavors: magna.bundle.flavors,

    removeSlotByProductId(productId) {
      const minusButton = document.querySelector(`[data-minus-button='${productId}']`);
      if (minusButton) {
        minusButton.click();
      }
    },

    variantEvent(event, productId) {
      window.dataLayer.push({
        event: event,
        product: this.flavors.find((flavor) => flavor.productId === productId),
      });
    },

    updateSlots(productId, variantId, qty) {
      const slotObj = this.flavors.find((flavor) => flavor.productId === productId);
      const foundSlot = this.slots.find((slot) => slot.productId === slotObj.productId);
      // Calculate total quantity excluding the current slot
      const otherSlotsQuantity = this.slots.reduce((acc, slot) => {
        if (!foundSlot || slot.productId !== foundSlot.productId) {
          return acc + slot.quantity;
        }
        return acc;
      }, 0);

      // Check if new quantity would exceed maxQty
      if (otherSlotsQuantity + qty > this.maxQty) {
        qty = Math.max(0, this.maxQty - otherSlotsQuantity);
      }

      if (foundSlot) {
        if (qty === 0) {
          this.slots = this.slots.filter((slot) => slot.productId !== slotObj.productId);
        } else {
          foundSlot.quantity = qty;
        }
      } else {
        if (slotObj) {
          slotObj.quantity = qty;
          this.slots.push(slotObj);
        }
      }
      this.scrollToFlavors();

      this.countSlotsQuantity();
      if (this.isMaxQuantityReached()) {
        this.scrollToForm();
      }
    },

    scrollToFlavors() {
      if (window.innerWidth < 768) {
        const flavors = document.querySelector('.build-bundle__builder-progress');
        if (flavors) {
          const headerOffset = 60;
          const elementBottom = flavors.getBoundingClientRect().bottom;
          const viewportHeight = window.innerHeight;
          // Calculate position to align element bottom with viewport bottom
          const offsetPosition = elementBottom + window.scrollY - viewportHeight + 5;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      }
    },

    scrollToForm() {
      if (window.innerWidth < 768) {
        const form = document.querySelector('.build-bundle__builder-form');
        if (form) {
          const headerOffset = 75;
          const elementBottom = form.getBoundingClientRect().bottom;
          const viewportHeight = window.innerHeight;
          const offsetPosition = elementBottom + window.scrollY - viewportHeight + 10;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      }
    },

    countSlotsQuantity() {
      if (!this.slots || !this.slots.length) return (this.totalSlotsQuantity = 0);

      this.totalSlotsQuantity = this.slots.reduce((accumulator, currentObject) => {
        return accumulator + parseInt(currentObject.quantity);
      }, 0);
    },

    async addToCart(event) {
      if (!this.slots) return;
      const button = event.target;
      const buttonText = button.innerText;
      button.classList.add('disabled');
      button.innerText = 'Mixing Your Magna...';
      const itemsForCart = [];
      console.log(this.formSellingPlanValue, 'this.formSellingPlanValue');

      if (this.formSellingPlanValue === 'one-time') {
        this.slots.forEach((slot) => {
          itemsForCart.push({
            id: slot.variantId,
            quantity: parseInt(slot.quantity),
            properties: {
              _bundle: 'buy 3 get 4th free',
            },
          });
        });
      } else {
        this.slots.forEach((slot) => {
          itemsForCart.push({
            id: slot.variantId,
            quantity: parseInt(slot.quantity),
            selling_plan: parseInt(this.currentSellingPlan),
            properties: {
              _dynamicBoxIndex: 0,
              _dynamicBoxId: this.box.boxId,
            },
          });
        });
      }

      const url = '/cart/add.js';
      const cart_drawer = document.querySelector('cart-drawer');

      const sections = cart_drawer.getSectionsToRender().map((section) => section.id);
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: itemsForCart,
            sections: sections,
          }),
        });
        if (!response.ok) {
          throw new Error('There was a problem with the request');
        }

        if (window.location.host.includes('drinkmagna')) {
          window.dataLayer.push({
            event: 'add_to_cart',
            items: itemsForCart,
          });
        }

        const json = await response.json();
        if (magna.bundle.addToCartType === 'drawer') {
          cart_drawer.renderContents(json);
        } else {
          document.location.href = '/cart/checkout';
        }
      } catch (e) {
        console.error(e.message);
        return null;
      } finally {
        button.classList.remove('disabled');
        button.innerText = buttonText;
      }
    },

    async fetchVariantData() {
      this.productId = document.querySelector('[data-product-id]')?.dataset.productId
        ? document.querySelector('[data-product-id]')?.dataset.productId
        : null;
      if (!this.productId) {
        console.error('Product ID not found');
        return { ok: false };
      }

      const response = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productPlatformId: this.productId,
        }),
      });

      return response.json();
    },

    isMaxQuantityReached() {
      return this.totalSlotsQuantity >= this.maxQty;
    },

    getSlotItem(index) {
      let currentIndex = 0;

      // Loop through all slots to find the right item for this index
      for (let slot of this.slots) {
        if (!slot) continue;

        // If this slot has multiple quantities
        for (let i = 0; i < slot.quantity; i++) {
          if (currentIndex === index) {
            return {
              ...slot,
              quantity: 1,
            };
          }
          currentIndex++;
        }
      }

      return null;
    },
  }));
});

// Klaviyo Star Rating Widget Customization
document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        const widget = document.querySelector('.kl_reviews__star_rating_widget');
        const summaryDiv = document.querySelector('.kl_reviews__summary__stars__count');
        if (
          (widget && !widget.classList.contains('modified')) ||
          (summaryDiv && !summaryDiv.classList.contains('modified'))
        ) {
          if (widget && !widget.classList.contains('modified')) modifyWidget(widget);
          if (summaryDiv && !summaryDiv.classList.contains('modified') && savedLabelText) modifySummaryDiv(summaryDiv);
          if (
            (!widget || widget.classList.contains('modified')) &&
            (!summaryDiv || summaryDiv.classList.contains('modified'))
          ) {
            observer.disconnect();
          }
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

function modifyWidget(widget) {
  // Extract the rating value, remove " stars", and round to one decimal place
  const originalRating = parseFloat(widget.getAttribute('aria-label').split(',')[0].trim().replace(' stars', ''));
  const roundedRating = Math.round(originalRating * 10) / 10;
  const ratingText = roundedRating.toFixed(1);

  // Create a new element for the rating
  const ratingElement = document.createElement('span');
  ratingElement.className = 'kl-rating-value';
  ratingElement.textContent = ratingText;

  // Insert the rating before the stars
  widget.insertBefore(ratingElement, widget.firstChild);

  // Change "ratings" to "reviews" and hide the original text
  const labelElement = widget.querySelector('.kl_reviews__star_rating_widget__label');
  if (labelElement) {
    const reviewsCount = labelElement.textContent.split(' ')[0];
    savedLabelText = reviewsCount + ' reviews';
    labelElement.textContent = savedLabelText;
    labelElement.style.display = 'none';
  }

  // Create a new element for "reviews" text
  const reviewsElement = document.createElement('span');
  reviewsElement.className = 'kl-reviews-text';
  reviewsElement.textContent = savedLabelText;
  widget.appendChild(reviewsElement);

  // Mark the widget as modified to prevent multiple modifications
  widget.classList.add('modified');

  // Clone and modify the widget for the product info section
  const productInfoRating = document.querySelector('.build-bundle__product-info-rating');
  if (productInfoRating && !productInfoRating.classList.contains('modified')) {
    const clonedWidget = widget.cloneNode(true);

    // Add click handler to trigger original widget
    clonedWidget.addEventListener('click', (e) => {
      e.preventDefault();
      widget.click();
    });

    productInfoRating.innerHTML = '';
    productInfoRating.appendChild(clonedWidget);
    productInfoRating.classList.add('modified');
  }
}

function modifySummaryDiv(div) {
  // Create a new label element
  const newLabel = document.createElement('span');
  newLabel.className = 'kl-summary-reviews-text';
  newLabel.textContent = savedLabelText;

  // Clear the existing content and add the new label
  div.innerHTML = '';
  div.parentElement.appendChild(newLabel);

  // Fix the product info rating update
  // const productInfoRating = document.querySelector('.build-bundle__product-info-rating');
  // if (productInfoRating) {
  //   productInfoRating.innerHTML = '';
  //   productInfoRating.appendChild(newLabel.cloneNode(true));
  // }

  // Mark the div as modified to prevent multiple modifications
  div.classList.add('modified');
}

// Add styles for both divs
const style = document.createElement('style');
style.textContent = `
    .kl_reviews__summary__stars__count {
      display: none;
    }
  `;
document.head.appendChild(style);
